import { colors } from "../styles";

interface BaseProps {
  index?: number | string;
  checked: boolean;
  onChange?: (e: any) => void;
  label?: string;
  borderColor?: string;
  className?: string;
}

const OptionButton = ({
  index,
  checked,
  label,
  onChange,
  borderColor = colors.orange650,
  className,
}: BaseProps) => {
  return (
    <button
      style={{
        background:
          borderColor === colors.orange650
            ? "none"
            : checked
            ? colors.gray900
            : "none",
        border: `${
          checked ? `1px solid ${borderColor}` : `1px solid ${colors.gray400}`
        }`,
        width: "100%",
        borderRadius: "6px",
        padding: "8px",
        color: `${checked ? borderColor : colors.gray700}`,
        fontWeight: `${checked ? 600 : 400}`,
        whiteSpace: "pre-line",
      }}
      className={className || "body3"}
      onClick={(e) => onChange?.(e)}
    >
      {label}
    </button>
  );
};

export default OptionButton;
